import { render, staticRenderFns } from "./AdminPageHeader.vue?vue&type=template&id=34dc39fe"
import script from "./AdminPageHeader.vue?vue&type=script&lang=js"
export * from "./AdminPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports